import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { FormGroupCreateService } from '../../services';

export const fetchFormGroupCreate = createAsyncThunk(
    'formGroupCreate/fetchFormGroupCreate',
    async ({ file, title, slug, description, content, pageId }) => {
        const response = await FormGroupCreateService(file, title, slug, description, content, pageId)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const formGroupCreateSlice = createSlice({
    name: 'formGroupCreate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFormGroupCreate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFormGroupCreate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchFormGroupCreate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default formGroupCreateSlice.reducer;
